import { InjectionToken } from '@angular/core';
import { Tenant } from '../env.type';

export const ACTIVE_TENANT = new InjectionToken<Tenant>('tenant.active');
